import { createGlobalStyle } from 'styled-components';

const LoginStyles = createGlobalStyle`
  .verification-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #1a237e 0%, #303f9f 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
  }

  .verification-card {
    background: white;
    padding: 3rem;
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
    width: 100%;
    max-width: 450px;
    text-align: center;
  }

  .verification-title {
    color: #1a237e;
    font-size: 2rem;
    margin-bottom: 1.5rem;
    font-weight: 600;
  }

  .verification-text {
    color: #666;
    margin-bottom: 2rem;
    font-size: 1.1rem;
    line-height: 1.6;
  }

  .pin-input-group {
    display: flex;
    gap: 1rem;
    justify-content: center;
    margin-bottom: 2rem;
  }

  .verify-button {
    width: 100%;
    padding: 1rem;
    background: #1a237e;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 1.1rem;
    cursor: pointer;
    transition: all 0.3s;
  }

  .verify-button:hover {
    background: #303f9f;
    transform: translateY(-2px);
  }

  .verify-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  .loading-spinner {
    display: inline-block;
  }

  .error-message {
    color: #e53935;
    margin-bottom: 1rem;
  }
`;

export default LoginStyles;